import { render } from "./Aboutus.vue?vue&type=template&id=19d9d8d8&ts=true&lang=pug"
import script from "./Aboutus.vue?vue&type=script&lang=ts"
export * from "./Aboutus.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__